import React, { useContext } from "react";
import { useTheme } from "styled-components";
import LinkButton from "common/Buttons/LinkButton";
import {
  ExternalAccountType,
  OnboardingDetailedStep,
} from "@shared/features/onboarding/types";
import { useIsOnboarding } from "utils/hooks/misc";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import { OnboardingStep } from "analytics/events";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface ConnectExternalAccountFooterProps {
  submitButton: React.JSX.Element;
  externalAccountType?: ExternalAccountType;
}

const ConnectExternalAccountFooter = ({
  submitButton,
  externalAccountType,
}: ConnectExternalAccountFooterProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const { analytics } = useContext(AnalyticsContext);
  const appTheme = useTheme();
  const isOnboarding = useIsOnboarding();
  const { changeStep } = useContext(OnboardingContext) || {};

  const onSkipClick = () => {
    if (isOnboarding && externalAccountType)
      analytics?.onboardingSkipExternalAccountClicked({
        onboardingStep: OnboardingStep.METHOD_SETTINGS,
        externalAccountType: externalAccountType,
      });
    changeStep?.(OnboardingDetailedStep.FOLLOW_SIGNALS_GROUP, {
      channelTab: "trial",
      guided: "0",
    });
  };

  return (
    <>
      {submitButton}
      {isOnboarding && (
        <div
          style={{
            textAlign: "center",
            marginTop: 8,
            color: appTheme.colors.textColor,
          }}
        >
          {t("external_account.footer.no_telegram_discord")}
          <LinkButton
            type="link"
            onClick={onSkipClick}
            style={{ width: "fit-content", padding: "0 0 0 4px" }}
          >
            {t("external_account.footer.skip_step")}
          </LinkButton>
        </div>
      )}
    </>
  );
};

export default ConnectExternalAccountFooter;
